import { createAsyncThunk } from '@reduxjs/toolkit';
import departmentsApi from '../../../api/departmentsApi';

const REDUCER_NAME = 'departments';

export const getDepartments = createAsyncThunk(`${REDUCER_NAME}/getDepartments`, async (__, thunkAPI) => {
  const res = await departmentsApi.get();
  if (res.status === 200) {
    return res.data;
  }
  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const CreateDepartment = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createDepartment`,
  async (data, thunkAPI) => {
    const res = await departmentsApi.create(data);
    if (res.status === 200) {
      return res.data;
    }
    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetSingleDepartment = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getSingleDepartment`,
  async (id, thunkAPI) => {
    const res = await departmentsApi.getSingle(id);
    if (res.status === 200) {
      return res.data;
    }
    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const EditDepartment = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/editDepartment`,
  async ({ id, data }, thunkAPI) => {
    const res = await departmentsApi.edit(id, data);
    if (res.status === 200) {
      return res.data;
    }
    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
